"use client";
import styled from "styled-components";
import InnerBanner from "@/components/InnerBanner";
import AboutOverview from "@/components/about/AboutOverview";
import ThreeFactor from "@/components/about/ThreeFactor";
import MissionVision from "@/components/about/MissionVision";
import CorporateValue from "@/components/about/CorporateValue";
import BOD from "@/components/about/BOD";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import Management from "./Management";
import { getApi } from "@/api";
import { ParallaxX, ParallaxXR, splitLeft } from "../animation/TextAnimation";
import { FadeUp } from "../animations/TextAnimations";
import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function About({ getAboutData }) {
  // const apiValue = "about";
  // const getAboutData = await getApi(apiValue);
  const pathName = usePathname();

  const getAboutDataList = getAboutData?.[0];
  const banner = getAboutDataList?.banner;
  const story = getAboutDataList?.story;
  const timeline = getAboutDataList?.timeline;
  const mission_vision = getAboutDataList?.mission_vision;
  const corporate_value = getAboutDataList?.corporate_value;
  const bod = getAboutDataList?.bod;
  const management = getAboutDataList?.management;

  // useSplitTextAnimation(".split-up", [data]);

  ParallaxX(getAboutData);
  ParallaxXR(getAboutData);
  splitLeft(getAboutData);
  FadeUp(getAboutData);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (window.location.hash) {
  //       gsap.to(window, {
  //         duration: 0.7,
  //         scrollTo: window.location.hash,
  //       });
  //     }
  //   }, 3000);

  //   if (pathName === "/about-us") {
  //     const getAllMenu = document.querySelectorAll(
  //       ".Main-menu__open__items__single a"
  //     );
  //     getAllMenu.forEach((e) => {
  //       e.addEventListener("click", (f) => {
  //         setTimeout(() => {
  //           gsap.to(window, {
  //             duration: 0.7,
  //             scrollTo: window.location.hash,
  //           });
  //         }, 3000);
  //       });
  //     });
  //   }
  // }, [pathName]);

  return (
    <section>
      <InnerBanner
        data={getAboutDataList}
        img={banner?.image ? banner?.image : "/images/static/blur_.jpg"}
        subtitle={banner?.subtitle}
        title={banner?.title}
        text={banner?.desc}
      />
      <AboutOverview sectionID={"our_story"} data={story} />
      <ThreeFactor sectionID={"core_values"} data={timeline} />
      <MissionVision sectionId={"mission_vision"} data={mission_vision} />
      <CorporateValue sectionID={"corporate_values"} data={corporate_value} />
      <BOD data={bod} />
      <Management sectionId={"management_team"} data={management} />
    </section>
  );
}
